/* eslint-disable import/prefer-default-export */
import Products from '../../api/Products';
import BasicNotification from '../../shared/components/Notifications/BasicNotification';
import {
  GET_PRODUCTS_BY_RUT_REQUEST,
  GET_PRODUCTS_BY_RUT_SUCCESS,
  GET_PRODUCTS_BY_RUT_FAILURE,
  CLEAR_PRODUCTS,
} from '../../api/Types';

export const getProductsByRut = (query, cb) => async (dispatch) => {
  dispatch({ type: GET_PRODUCTS_BY_RUT_REQUEST });
  try {
    const { body, header } = await Products.getByRut(query);
    const count = header['x-pagination-total-count'];
    const limit = header['x-pagination-limit'];
    if (cb) {
      cb(body);
    }
    dispatch({ type: GET_PRODUCTS_BY_RUT_SUCCESS, payload: { body, count, limit } });
  } catch (error) {
    dispatch({ type: GET_PRODUCTS_BY_RUT_FAILURE, error });
    BasicNotification.error('Ocurrió un error al intentar obtener los productos.');
  }
};

export const clearProducts = () => (dispatch) => {
  dispatch({ type: CLEAR_PRODUCTS });
};
